import { StatusEnumDto } from '../../api/web-api-client';

export interface Filters {
    year?: number;
    status?: StatusEnumDto;
    sortOrder?: string;
}

export interface InitialFilters {
    filterYearType: string;
    filterStatusType: string;
    filtersChanged: boolean;

}
export interface UserProfile {
    filterYearType?: string;
    filterStatusType?: string;
    filterSortOrder?: string;
    filtersChanged?: boolean;
    filterCurrentPage?: number;
    filterActiveTab?: DashboardTab;
    filterSearchText?: string;
}

export interface SearchFilterProps {
    containerClassName?: string;
    className?: string;
    initialFilters: UserProfile | undefined;
    setInitialFilters: React.Dispatch<React.SetStateAction<UserProfile | undefined>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    placeholder?: string;
}

export enum DashboardTab {
    Drafts = 'drafts',
    Requests = 'requests',
    Instruments = 'instruments',
}
